import React, {useContext, useState} from 'react';
import {useDropzone} from 'react-dropzone'
import importImg from "../../assets/images/upload.svg"
import ConfirmationModel from "../ConfirmationModel";
import {emailValidateWithRequired, required} from "../Field/validate";
import Field from "../Field";
import authContext from "../../AuthProvider/authContext";
import axios from "axios";
import {handleError, showsuccesToast} from "../HandleError";
import {ImSpinner6} from "react-icons/im";
import {Formik} from "formik";
import localized from '../../i18n';
import {Alert, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane, UncontrolledAlert} from "reactstrap";
import {useNavigate,Link} from "react-router-dom";
import {Button} from "react-bootstrap";


const ImportList = (props) => {
    const {state,updateAuth} = useContext(authContext);
    const {auth} = state
    const [showFileModel, setFileModel] = useState(false);
    const [currentFile, setCurrentFile] = useState([]);
    const [activeTab, setActiveTab] = useState("1");
    const [emailResponse, setEmailResponse] = useState("")
    const [showMessage, setShowMessage] = useState(false)
    const [loading, setloading] = useState(false)
    const navigate = useNavigate();

    const toggleFileUploadModel = (file = []) => {
        setCurrentFile(file);
        setFileModel(!showFileModel);
    }

    const onDropFiles = ({name}) => {
        const formData = new FormData();
        formData.append("file", currentFile[0]);
        formData.append("name", name);
        formData.append("api_key", state.auth.api_key);
        axios.post("/api/upload", formData)
            .then((response) => {
                props.getFilesList(1, false);
                toggleFileUploadModel();
                showsuccesToast(localized.file_uploaded_successfully);
                onShowAlert();
            }).catch((err) => {
            toggleFileUploadModel();
            handleError(err);
        })
    }
    const callEmail = (values) => {
        setEmailResponse("");
        setloading(true)
        axios.post("/api/verify/email", values)
            .then((res) => {
                setEmailResponse(res.data.data);
                console.log(res.data.data)
                setloading(false)
                updateAuth({auth:{...auth,available_credit:auth.available_credit-1}})
            })
            .catch(() => {
                setloading(false)
            })
    }
    const onShowAlert = ()=>{
        setShowMessage(true)
        window.setTimeout(()=>{
            setShowMessage(false)
        },10000)
    }
    const redirectToPricingPlan = () => {
        navigate("/pricing-plan");
    }
    const {
        getRootProps,
        getInputProps,
    } = useDropzone({
        onDrop: toggleFileUploadModel,
        accept: {
            'file/csv': ['.csv'],
            'text/plain': ['.txt'],
        }
    });

    return (
        <>
            <div className="import-list-Box">
                <div className={"m-0 import-list-container"}>
                    <Col className={`email-submit-main-container ${activeTab === "2" ? "bg-image" : 0}`}>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={activeTab === "1" ? "active" : ""}
                                    onClick={() => setActiveTab("1")}
                                >
                                    {localized.List}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeTab === "2" ? "active" : ""}
                                    onClick={() => setActiveTab("2")}
                                >
                                    {localized.Single}
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab} className={"h-100"}>
                            <TabPane tabId="1">
                                <Col className="import-content">
                                    <h2>{localized.Verify_an_email_list}</h2>
                                    <div {...getRootProps()} className="importlist-conatiner">
                                        <input accept={'.csv , .txt'} {...getInputProps()} />
                                        <img src={importImg} alt="import"/>
                                        <p>{localized.import_a_list_to_be_checked}</p>
                                    </div>
                                    <div className="importlist-footer">
                                        <p dangerouslySetInnerHTML={{__html: localized.Download_the_CSV}}/>
                                        <p dangerouslySetInnerHTML={{__html: localized.add_email}}/>
                                        <p dangerouslySetInnerHTML={{__html: localized.email_credit}}/>
                                    </div>
                                    <p className={"balance"}>{localized.Your_balance} {auth.available_credit ? auth.available_credit : "0"} {localized.credits}</p>
                                    {showMessage &&
                                    <UncontrolledAlert color="success" className="mt-2 w-10 m-auto">
                                        {localized.list_submitted}
                                    </UncontrolledAlert>
                                    }
                                </Col>
                            </TabPane>
                            <TabPane tabId="2" className={"h-100"}>
                                <Col className={"h-100"}>
                                    <div className="email_credit_box h-100">
                                        <div className="verify_single_email">
                                            <div className="verify-email ">
                                                <h2>{localized.Verify_a_single_email}</h2>
                                                <div className="verify-email-form mx-auto">
                                                    <Formik initialValues={{
                                                        email: "",
                                                    }}
                                                            onSubmit={(values) => callEmail(values)}>
                                                        {props => {
                                                            const {handleSubmit} = props;
                                                            return (
                                                                <form onSubmit={handleSubmit}
                                                                      className=" gap-2 m-auto">
                                                                    <div className="d-flex align-items-start gap-2 input-container">
                                                                        <Field
                                                                            placeholder={"Enter Email"}
                                                                            name="email"
                                                                            type="email"
                                                                            disabled={loading}
                                                                            validate={emailValidateWithRequired}
                                                                        />
                                                                        <Button type="submit"
                                                                                className="btn mt-1 btn-secondary d-flex align-items-center gap-1 text-center"
                                                                                disabled={loading}>{localized.Verify}{loading &&
                                                                        <ImSpinner6
                                                                            className="importing-spinner"/>}</Button>
                                                                    </div>
                                                                </form>
                                                            )
                                                        }}
                                                    </Formik>
                                                </div>
                                                {emailResponse !== "" &&
                                                <UncontrolledAlert color="success" className="mt-2 w-75 m-auto">
                                                    {emailResponse}
                                                </UncontrolledAlert>}
                                                <div>
                                                    <p>{localized.added_email}</p>
                                                </div>
                                                <p className={"balance"}>{localized.Your_balance} {auth.available_credit ? auth.available_credit : "0"} {localized.credits}</p>
                                                <div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </TabPane>
                        </TabContent>
                    </Col>
                    <Col className={"email-submit-main-container"}>
                       <div className={"inner-content"}>
                           <div className={"left-side"}>
                               <h3>{localized.Check_out_more_emails}</h3>
                               <Link to={'/pricing-plan'}>
                                   <Button>{localized.Buy}</Button>
                               </Link>
                           </div>
                           <div className={"right-side"}>
                               <p>{localized.Buy_plan}</p>
                           </div>
                       </div>
                    </Col>
                </div>
            </div>
            <ConfirmationModel
                initialValues={{name: ""}}
                bodyContent={
                    <Field
                        label={localized.file_name}
                        name="name"
                        type="text"
                        placeholder={localized.file_name}
                        validate={required}
                    />
                }
                isOpen={showFileModel}
                submitBtn={"confirm"}
                className={"logout-modal"}
                onClose={() => toggleFileUploadModel()}
                onSubmit={onDropFiles}
            />
        </>
    );
};

export default ImportList;